import { createApp } from 'vue';
import App from './App.vue';
import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: '8ec246d4-628e-4be8-abee-9936acd1b1eb', // Your application (client) ID
    authority: 'https://login.microsoftonline.com/5e5310c9-5eb4-4805-97dc-bfcaefcd29ae', // Your tenant ID
    redirectUri: 'https://iconicsweb.cjc.dk' // Your redirect URI (e.g., localhost during dev)
  }
};

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before Vue app starts
msalInstance.initialize().then(() => {
  const app = createApp(App);
  app.config.globalProperties.$msalInstance = msalInstance;
  app.mount('#app');
}).catch(error => {
  console.error('MSAL initialization error:', error);
});